import React, {Component} from 'react'
import {reduxForm, Field} from 'redux-form'
import SostaOnlineApiService from '../services/SostaOnlineApiService'

class BackOfficeUserDetailVehicleEditForm extends Component {
  constructor (props) {
    super(props)
    this.state = {
      loading: true,
      errors: false,
      ownershipTypes: [],
      powerSupplies: []
    }
  }

  async componentWillMount () {
    try {
      this.setState({loading: true})
      let promises = [
        SostaOnlineApiService.fetchVehicleOwnershipTypes(),
        SostaOnlineApiService.fetchVehiclePowerSupplies()
      ]

      const result = await Promise.all(promises)

      if (result.filter(item => item.result !== 'ok').length > 0) {
        this.setState({errors: true, loading: false})
        return
      }

      this.setState({
        ownershipTypes: result[0].data,
        powerSupplies: result[1].data,
        loading: false
      })
    } catch (e) {
      this.setState({loading: false, errors: true})
    }
  }

  render () {
    const {error, handleSubmit, vehicle, status} = this.props

    if (this.state.loading) {
      return (<div className="box">
        Caricamento in corso...
      </div>)
    }

    if (this.state.errors) {
      return (<div className="box text-danger">
        Errore nel caricamento dei dati...
      </div>)
    }

    return (
      <form onSubmit={handleSubmit}>

        <div className="card">
          <div className="caption">
            <div className="col-md-12">
              <Field name="VehicleOwnershipTypeId" className="form-control" component="select" required>
                <option value="">Seleziona tipo di proprietà...</option>
                {this.state.ownershipTypes.map((item, index) => {
                  return (<option value={item.id} key={item.id + '-' + index}>
                    {item.name}
                  </option>)
                })}
              </Field>
              <br />
              <Field component="input" name="plate_number" placeholder="TARGA" type="text" className="resident-login" required />

              <div className="col-md-12">
                <Field name="VehiclePowerSupplyId" className="form-control" component="select" required>
                  <option value="">Seleziona alimentazione veicolo...</option>
                  {this.state.powerSupplies.map((item, index) => {
                    return (<option value={item.id} key={item.id + '-' + index}>
                      {item.name}
                    </option>)
                  })}
                </Field>
              </div>
              {status === 'loading' && <span>Modifica in Corso</span>}
              {status === 'error' && <span>Errore nella modifica del veicolo</span>}
              {status === 'success' && <span>Veicolo Modificato Correttamente</span>}
            </div>

            {status === 'success' && <button onClick={this.props.onCloseVehicleEdit} type="button" className="btn btn-primary btn-xs btn-update btn-add-card">Chiudi</button>}
            {(status !== 'success' && status !== 'loading' && status !== 'error') && <button onClick={this.props.onCancelClick} type="button" className="btn btn-danger btn-xs btn-update btn-add-card"><i className="glyphicon glyphicon-remove-circle">{}</i> Annulla</button>}
            {(status !== 'success' && status !== 'loading' && status !== 'error') && <button type="submit" className="btn btn-success btn-xs btn-update btn-add-card"><i className="glyphicon glyphicon-ok-circle">{}</i> Conferma</button>}
          </div>
        </div>
      </form>
    )
  }
}

export default reduxForm({
  form: 'backofficeUserDetailVehicleEdit'
})(BackOfficeUserDetailVehicleEditForm)



// WEBPACK FOOTER //
// ./src/components/BackOfficeUserDetailVehicleEditForm.js